import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class ChatBotCreateConversationRequest {
  title: string;
  userId: string;
  message: string;
}

export interface Conversation {
  id: string;
  title: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

export interface UserMessage {
  id: string;
  role: 'user' | 'assistant';
  message: string;
  createdAt: string;
  updatedAt: string;
}

export interface AssistantMessage {
  id: string;
  role: 'user' | 'assistant';
  message: string;
  createdAt: string;
  updatedAt: string;
}

export class ChatBotConversationResponse {
  conversation: Conversation;
  userMessage: UserMessage;
  assistantMessage: AssistantMessage;
}

export class ChatBotMessageRequest {
  message: string;
  conversationId: string;
}

export class ChatBotMessageResponse {
  userMessage: UserMessage;
  assistantMessage: AssistantMessage;
}

export class ChatBotConversationItem {
  id: string;
  title: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

export class ChatBotConversationsListResponse extends IPagination {
  @Type(() => ChatBotConversationItem)
  results: ChatBotConversationItem[];
}

export class ConversationItem {
  id: string;
  title: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

export class Message {
  id: string;
  conversationId: string;
  role: 'user' | 'assistant';
  message: string;
  createdAt: string;
  updatedAt: string;
}

export class ChatConversationByIdResponse {
  @Type(() => ConversationItem)
  conversation: ConversationItem;
  @Type(() => Message)
  messages: Message[];
}

export class ConversationsQueryDto extends IQueryPaginationDto {}
